import { nullToZero, nullToEmptyString, nullToFalse } from "src/app/shared/helpers/shared-zero-to-null.function";
import { ExtRfrSaveI } from "./rfr-save.result.ext";
import { ExtRfrSaveQueryI } from "./rfr-save.query.ext";
import { RfrSaveQueryI } from "./rfr-save.query.int";
import { RfrSaveI } from "./rfr-save.result.int";

export const MapRfrSave = {
  mapQuery: (int: RfrSaveQueryI): ExtRfrSaveQueryI => ({
      request: {
        piSeqnr: int.seqNr,
        pdTemperature: nullToZero(int.reeferTemperature),
        pdHumidity: nullToZero(int.humidity),
        pcVentilation: nullToEmptyString(int.ventilation),
        pcBoxref3: nullToEmptyString(int.defrostInterval),
        pcBoxref4: nullToEmptyString(int.ventilationValue),
        pcBoxref5: nullToEmptyString(int.ventilationUnit),
        pcDrains: nullToEmptyString(int.drains),
        pcSealnrTerminal: nullToEmptyString(int.sealNrTerminal),
        plExtraPTI: nullToFalse(int.extraPTI),
      }
    }),
  mapResult: (_ext: ExtRfrSaveI): RfrSaveI =>  ({
  }),
};